import { LinePath } from "@visx/shape";
import { line } from "d3-shape";
import { observer } from "mobx-react";
import { forwardRef, useImperativeHandle } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const _LineChart = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    id,
    chartItem,
    scales,
    color
  } = _ref;
  useImperativeHandle(ref, () => ({
    doZoom(scales) {
      const el = document.querySelector("#".concat(id, " path"));
      if (!el) return;
      const path = line().x(p => scales.x(p.x)).y(p => scales.y(p.y));
      el.setAttribute("d", path(chartItem.points));
    }
  }), [id, chartItem]);
  const stroke = color || chartItem.getColor();
  return /*#__PURE__*/_jsx("g", {
    id: id,
    children: /*#__PURE__*/_jsx(LinePath, {
      data: chartItem.points,
      x: p => scales.x(p.x),
      y: p => scales.y(p.y),
      stroke: stroke,
      strokeWidth: 2
    })
  });
});
_LineChart.displayName = "LineChart";
export default observer(_LineChart);